import type * as React from 'react';
import { cn } from './cn';

/**
 * The `<label>` of the design system. Which control it names is the caller's
 * to say — it arrives through `htmlFor` in the spread props, which is why the
 * association cannot be checked from here.
 */
function Label({ className, ...props }: React.ComponentProps<'label'>) {
  return (
    // biome-ignore lint/a11y/noLabelWithoutControl: htmlFor comes from the caller
    <label
      className={cn(
        'text-xs font-medium leading-none text-muted-foreground peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
        className
      )}
      {...props}
    />
  );
}

export { Label };
